import {CheckCircleOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

type GetStartedWidgetItemProps = {
  number: number | string;
  isDone: boolean;
  handleClick: () => void;
  text: string;
};

export function GetStartedWidgetItem({
  handleClick,
  isDone,
  number,
  text,
}: GetStartedWidgetItemProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "3.2rem",
      }}
    >
      {isDone ? (
        <>
          <CheckCircleOutlined
            style={{
              fontSize: "2.4rem",
              color: "#355D2C",
            }}
          />
          <span
            style={{
              color: "#BFBFBF",
              fontSize: "1.4rem",
              fontWeight: 600,
            }}
          >
            {text}
          </span>
        </>
      ) : (
        <>
          <div
            style={{
              width: "2.4rem",
              height: "2.4rem",
              backgroundColor: "#99C78F",
              border: "1px solid #355D2C",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#355D2C",
              fontSize: "1.4rem",
              fontWeight: 600,
              borderRadius: "50%",
            }}
          >
            {number}
          </div>
          <span
            onClick={handleClick}
            style={{
              fontSize: "1.4rem",
              fontWeight: 600,
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        </>
      )}
    </div>
  );
}
